import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { CollectionIssueEventModel } from "./models";

export type GetCollectionIssueHistoryRequest = {
  addressUnitNo: string;
  addressStreetNo: string;
  addressStreetName: string;
  addressSuburbName: string;
  addressStateCode: string;
  addressPostCode: string;
  addressCountry: string;
};

export type GetCollectionIssueHistoryResponse = {
  collectionIssues: CollectionIssueEventModel[];
};

export const getCollectionIssueHistory = async (request: GetCollectionIssueHistoryRequest) => {
  const response = await executeApiRequest(
    () => axios.get<GetCollectionIssueHistoryResponse>(`/collectionissuehistory`, { params: request }),
    false
  );

  return response?.data.collectionIssues;
};
